import * as angular from "angular";
import { playService } from "../services/app";
import { playUserbox } from "../userbox/app";
import { characters, words } from "./RSSFilter";
import { MatchListController, MatchItemController } from "./MatchList";
import { NewsRssController } from "./RSS";
import { component } from "../Component";

export let playPanel = angular.module("play.panel", ["ngResource", playService.name, playUserbox.name]);

playPanel.filter("characters", characters);
playPanel.filter("words", words);

playPanel.component(
    "matchlist",
    component({
        bindings: {
            leagueId: "<",
            limit: "<",
            maxClosed: "<",
            maxOpen: "<",
            maxChallenge: "<",
            maxProtest: "<",
            maxAgeClosed: "<",
        },
        templateCacheUrl: "panels/match-list.html",
        controllerAs: "ctrl",
        controller: MatchListController,
    })
);

playPanel.component(
    "matchitem",
    component({
        bindings: {
            id: "<",
        },
        templateCacheUrl: "panels/math-item.html",
        controllerAs: "ctrl",
        controller: MatchItemController,
    })
);

playPanel.component(
    "newsrss",
    component({
        bindings: {
            feedUrl: "<",
            maxNews: "<",
            showImages: "<",
            characterLimit: "<",
        },
        templateCacheUrl: "panels/rss.html",
        controllerAs: "ctrl",
        controller: NewsRssController,
    })
);
